module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/17-42f2f65f15fea1f769448f00a979ef4d.jpg";